import { render, staticRenderFns } from "./dados-civ.vue?vue&type=template&id=2cb5f317"
import script from "./dados-civ.vue?vue&type=script&lang=js"
export * from "./dados-civ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports